import { Actioner } from "@services/actioner";
import { Result, type StringResult } from "@services/sdk/models";
import ErrorResponseFactory from "@services/sdk/models/error-response-factory";
import type { AxiosInstance } from "axios";

export const createMRTMPaymentAdapter = (httpClient: AxiosInstance) => ({
	async getPaymentToken(): Promise<StringResult> {
		try {
			const response = await httpClient.get("/payment/token");
			return Result.Success(response.data.data.clientToken);
		} catch (err: any) {
			Actioner.trigger(Actioner.keyDefs.ERROR, err);
			return Result.Failure(ErrorResponseFactory.ErrorGetPaymentToken(err));
		}
	},
});
